export function formatDecimalNumber(value: number, decimal: number = 2): string {
  if (value - Math.floor(value) === 0) return `${value}`;
  return value.toFixed(decimal);
}

export function formatVariation(value: number, decimal: number = 2): string {
  const variation = Math.abs(+formatDecimalNumber(value, decimal));
  return value < 0 ? `-${variation}` : `+${variation}`;
}
